<div class="mkt-template-type-dialog">
  <div class="mkt-template-type-dialog-header flex-between-center">
    <p class="m-0 font-bold flex-start-center">
      <i class="far fa-bullseye pr-2"></i>
      <span>Select template type</span>
    </p>

    <span class="close-modal">
      <i class="fal fa-times" (click)="handleClose()"></i>
    </span>
  </div>

  <div class="mkt-template-type-dialog-body flex-column flex-wrap flex-start-start">
    <div class="mkt-template-inner-body">
      <div *ngFor="let option of options" class="option-box ui-g-12 p-0">
        <div class="ui-g-1 p-0 flex-center-center">
          <i class="{{ option?.icon }} option-box-icon font-14"></i>
        </div>

        <div class="ui-g-11 p-0 flex-column">
          <p class="m-0 font-14 pb-1">{{ option?.label }}</p>
          <div class="ui-g-12 p-0">
            <div *ngFor="let subOption of option?.subOptions" class="ui-g-6 p-0 icon-box-wrapper pointer">
              <div
                class="icon-box flex-column flex-center-center position-relative"
                [ngClass]="{ selected: template[option?.key] === subOption?.value }"
                (click)="handleChange(option?.key, subOption?.value)"
              >
                <i class="{{ subOption?.icon }} option-icon"></i>
                <i class="fas fa-check icon-check" *ngIf="template[option?.key] === subOption?.value"></i>
                <p class="m-0">{{ subOption?.label }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="option-box ui-g-12 p-0" *ngIf="template?.templateType === marketingTemplateTypes?.EMAIL && template?.campaignType === campaignTypes?.PROMOTIONAL">
        <div class="ui-g-1 p-0 flex-center-center">
          <i class="far fa-th option-box-icon font-14"></i>
        </div>

        <div class="ui-g-11 p-0 flex-column">
          <p class="m-0 font-14 pb-1">Choose template</p>
          <div class="ui-g-12 p-0">
            <div *ngFor="let emailTemplate of emailTemplateOptions" class="ui-g-6 p-0 icon-box-wrapper email-template pointer">
              <div
                class="icon-box flex-between-center"
                [ngClass]="{ selected: template?.emailTemplateType === emailTemplate?.value }"
                (click)="handleChange('emailTemplateType', emailTemplate?.value)"
              >
                <div class="d-flex">
                  <i class="{{ emailTemplate?.icon }} option-icon"></i>
                  <p class="m-0 ml-2 pt-1">{{ emailTemplate?.label }}</p>
                </div>
                <div *ngIf="template?.emailTemplateType === emailTemplate?.value">
                  <i class="fas fa-check"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="mkt-template-type-dialog-footer flex-end-center">
    <button class="btn btn-border pointer btn-submit mr-1" (click)="handleClose()">
      Cancel
    </button>

    <button class="btn btn-primary btn-submit" [disabled]="!template?.templateType || !template.campaignType" (click)="handleSave()">
      Create
    </button>
  </div>
</div>
